module.exports = __webpack_public_path__ + "img/travel_mode.69f1a7d8.svg";